import Vue from 'vue'
import Vuex from 'vuex'
import store_modular from '@/store/modules/index.js'
import user from './modules/user'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    store_modular,
    user
  }
})
